import BasicLayout from "./BasicLayout";
import InputField from "components/fields/InputField";

const Step6 = ({ state, setState, message }) => {
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setState((state) => ({
            ...state,
            data: {
                ...state.data,
                [name]: value,
            },
        }));
    };

    return (
        <BasicLayout
            title="IP"
            subtitle={
                <>
                    Inserisci l’IP pubblico da qui, così da rendere il tuo
                    server raggiungibile da Internet.
                    <br />
                    Questo dato è necessario per completare la configurazione e
                    consentire l’accesso ai servizi della piattaforma.
                    <br />
                    Inoltre, questo indirizzo IP verrà utilizzato per la
                    ricezione e la validazione delle licenze sulla piattaforma.
                    <br />
                    <br />
                    <strong>
                        N.B. Se in futuro vorrai modificare l’indirizzo IP,
                        potrai farlo anche dopo l’attivazione della piattaforma,
                        inviando una richiesta via e-mail al supporto tecnico.
                    </strong>
                </>
            }
            content={
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                    <InputField
                        extra="mb-4"
                        label="IP per FQDN*"
                        placeholder=""
                        name="ip_fqdn"
                        type="text"
                        value={state.data.ip_fqdn || ""}
                        onChange={handleChange}
                        required={true}
                        state={
                            message.hasOwnProperty("errors")
                                ? message.errors.hasOwnProperty("data.ip_fqdn")
                                    ? "error"
                                    : null
                                : null
                        }
                        error={
                            message.hasOwnProperty("errors")
                                ? message.errors.hasOwnProperty("data.ip_fqdn")
                                    ? message.errors["data.ip_fqdn"]
                                    : null
                                : null
                        }
                    />
                </div>
            }
        />
    );
};

export default Step6;
